import React from 'react';
import { ScheduleItem } from '@app-types';
import styles from './SchedulerTableCells.module.css';

const InProgressCell: React.FC<{
  scheduleItem: ScheduleItem;
  isGroupRow: boolean;
  isChildRow: boolean;
}> = ({ scheduleItem, isChildRow }) => {
  if (isChildRow) {
    return (
      <div className={styles.inProgressCell}>
        <span className={styles.emptyCell}>—</span>
      </div>
    );
  }

  const processedByName = scheduleItem.processed_by?.name;

  return (
    <div className={styles.inProgressCell}>
      <span className={styles.inProgressText}>
        {processedByName || <span className={styles.noDate}>Not in progress</span>}
      </span>
    </div>
  );
};

export default InProgressCell;
